import { produce } from 'immer'
import baseReducer from '@utilities/base-reducer'
import * as Actions from './plan-action'

const initialState = {
  verifyExists: null,
}

const verifyExistsReducer = baseReducer(initialState, {
  [Actions.REQUEST_VERIFY_EXISTS_PLAN_FINISHED](state, action) {
    return produce(state, draftState => {
      draftState.verifyExists = action.payload
    })
  },
})

export default verifyExistsReducer
